document.addEventListener('DOMContentLoaded',function() {
    
    const offers = document.getElementById('offers');

    const init = function() {

        const blob = offers.getElementsByClassName('js-blob');
                            
        for (let i = 0; i < blob.length; i++) {            
            blob[i].addEventListener('mouseover', function(e) {
                document.documentElement.classList.add('offers-blob-hover');
                e.currentTarget.classList.add('is-active');
            })
            
            blob[i].addEventListener('mouseout', function(e) {
                document.documentElement.classList.remove('offers-blob-hover');
                
                for (let j = 0; j < blob.length; j++) {
                    blob[j].classList.remove('is-active');
                }
            })
            
            blob[i].addEventListener('click', function(e) {
                if (e.currentTarget.dataset.url){
                    window.open('/rezultat-wyszukiwania.html?categories=' + e.currentTarget.dataset.url, '_self');
                } else {
                    // window.offerSearchComponent.openCategory(e.currentTarget.dataset.category);
                    window.runScroll(e.currentTarget.dataset.target);
                }
            })
        }
    };

    offers ? init() : false;

}, false)
